import { assessmentMethods } from './pdpl.assessment';
import { evidenceMethods } from './pdpl.evidence';
import { categoryWorkflowMethods } from './pdpl.categoryWorkflow';
import { submissionsMethods } from './pdpl.submissions';
import { autoChecksMethods } from './pdpl.autoChecks';

export { pdplCacheKeys } from './pdpl.cacheKeys';

export const pdplApi = {
  ...assessmentMethods,
  ...evidenceMethods,
  ...categoryWorkflowMethods,
  ...submissionsMethods,
  ...autoChecksMethods,
};
